export default __webpack_public_path__ + "static/media/math_color.036f850c38c239dff0a1eba23f311f74.svg";